import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import BackgroundFields, { Field, inputClass } from './BackgroundFields';
import SectionBackgroundFields from './SectionBackgroundFields';
import PaddingFields from './PaddingFields';
import MenuTabsOrderFields from './MenuTabsOrderFields';
import { buildDefaultTabPlacements, MENU_LAYOUT_COLUMNS } from '../utils/menuLayout';
import FontFamilySelectField from './FontFamilySelectField';
import MenuTypographyFields from './MenuTypographyFields';
import ButtonTypographyFields from './ButtonTypographyFields';
import MenuExternalLinksFields from './MenuExternalLinksFields';
import MenuButtonsFields from './MenuButtonsFields';
import MenuTabShapeFields from './MenuTabShapeFields';
import WebCreatorTextEditor from './WebCreatorTextEditor';
import HubupCommunityFields from './HubupCommunityFields';
import ColorFillField from './ColorFillField';
import IconPickerField from './IconPickerField';
import DropdownOptionsFields from './DropdownOptionsFields';
import ShapeFields from './ShapeFields';
import ComponentAnimationFields from './ComponentAnimationFields';
import SectionAnimationFields from './SectionAnimationFields';
import CampaignProductFields from './CampaignProductFields';
import TextComponentEffectFields from './TextComponentEffectFields';
import TextBlockTypographyFields from './TextBlockTypographyFields';
import HoverEffectFields from './HoverEffectFields';
import { resolveIconStrokeColor, resolveColorFillStyle } from '../utils/colorFillUtils';
import { formatProductPriceEur, resolveProductDisplay } from '../utils/campaignWebCreator';
import {
  DEFAULT_BACKGROUND,
  DEFAULT_COMPONENT_BACKGROUND,
  DEFAULT_TEXT_HTML,
  createSectionBackground,
  resolveComponentPadding,
  resolveButtonStyle,
  resolveDropdownStyle,
  resolveBadgeStyle,
  resolveShapeRadius,
  siteHasCustomFont,
  getSiteDefaultFont,
  buildDefaultTabOrder,
  getMenuTabOrderEditorEntries,
  hasViewportAnimationOverride,
  getViewportAnimationSource,
  setViewportAnimation,
  clearViewportAnimationOverride,
  defaultComponentProps,
} from '../utils/defaults';
import EditorModalPortal from './EditorModalPortal';
import ViewportVisibilityFields from './ViewportVisibilityFields';
import SectionViewportVisibilityFields from './SectionViewportVisibilityFields';
import RestaurantContentSettingsFields from './RestaurantContentSettingsFields';
import {
  TextKitStyleField,
  TextLinkFields,
  ButtonKitStyleField,
  ImageKitStyleField,
  SectionDesignKitField,
} from './DesignKitStyleFields';
import { RESTAURANT_SECTION_VARIANT_LABELS } from '../utils/restaurantExempleDefaults';
import { siteUsesDesignKit } from '../utils/designKit';
import {
  CardFeatureContentFields,
  CardFeatureAppearanceFields,
  CardIllustrationContentFields,
  CardIllustrationAppearanceFields,
  CardSplitContentFields,
  CardSplitAppearanceFields,
  CardSharedAppearanceFields,
} from './CardComponentSettingsFields';

const SECTION_TABS = [
  { id: 'general', label: 'Général', icon: 'FileText' },
  { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  { id: 'animation', label: 'Animation', icon: 'Sparkles' },
];

const COMPONENT_TABS = {
  text: [
    { id: 'content', label: 'Contenu', icon: 'Type' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  image: [
    { id: 'content', label: 'Image', icon: 'Image' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  button: [
    { id: 'content', label: 'Contenu', icon: 'MousePointerClick' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  clickAndCollect: [
    { id: 'content', label: 'Bouton', icon: 'ShoppingCart' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  reservation: [
    { id: 'content', label: 'Bouton', icon: 'CalendarCheck' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  dropdown: [
    { id: 'content', label: 'Options', icon: 'ChevronDown' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  divider: [
    { id: 'content', label: 'Contenu', icon: 'Minus' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  badge: [
    { id: 'content', label: 'Texte', icon: 'Tag' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  quote: [
    { id: 'content', label: 'Citation', icon: 'MessageCircle' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  icon: [
    { id: 'content', label: 'Icône', icon: 'Sparkles' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  product: [
    { id: 'content', label: 'Produit', icon: 'ShoppingBag' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  cardFeature: [
    { id: 'content', label: 'Contenu', icon: 'LayoutGrid' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  cardIllustration: [
    { id: 'content', label: 'Contenu', icon: 'Image' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  cardSplit: [
    { id: 'content', label: 'Contenu', icon: 'LayoutTemplate' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  menu: [
    { id: 'navigation', label: 'Navigation', icon: 'Menu' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  hubupQr: [
    { id: 'content', label: 'Communauté', icon: 'QrCode' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  hubupNotifications: [
    { id: 'content', label: 'Contenu', icon: 'Bell' },
    { id: 'appearance', label: 'Apparence', icon: 'Palette' },
  ],
  restaurantPage: [{ id: 'content', label: 'Contenu', icon: 'UtensilsCrossed' }],
  restaurantSection: [{ id: 'content', label: 'Contenu', icon: 'LayoutTemplate' }],
};

function getTabs(isSection, type) {
  if (isSection) return SECTION_TABS;
  if (type === 'restaurantPage' || type === 'restaurantSection') {
    return COMPONENT_TABS[type] || [{ id: 'content', label: 'Contenu', icon: 'UtensilsCrossed' }];
  }
  const base = COMPONENT_TABS[type] || [{ id: 'appearance', label: 'Apparence', icon: 'Palette' }];
  const withResponsive = base.some((t) => t.id === 'responsive')
    ? base
    : [...base, { id: 'responsive', label: 'Responsive', icon: 'MonitorSmartphone' }];
  if (withResponsive.some((t) => t.id === 'animation')) return withResponsive;
  return [...withResponsive, { id: 'animation', label: 'Animation', icon: 'Sparkles' }];
}

function typeLabel(type, restaurantVariant) {
  switch (type) {
    case 'text':
      return 'Texte';
    case 'image':
      return 'Image';
    case 'button':
      return 'Bouton';
    case 'dropdown':
      return 'Menu déroulant';
    case 'divider':
      return 'Séparateur';
    case 'badge':
      return 'Badge';
    case 'quote':
      return 'Citation';
    case 'icon':
      return 'Icône';
    case 'product':
      return 'Produit';
    case 'cardFeature':
      return 'Carte icônes & lien';
    case 'cardIllustration':
      return 'Carte illustration';
    case 'cardSplit':
      return 'Carte texte & image';
    case 'menu':
      return 'Menu';
    case 'hubupQr':
      return 'QR HubUP';
    case 'hubupNotifications':
      return 'Notifications HubUP';
    case 'clickAndCollect':
      return 'Click & collect';
    case 'reservation':
      return 'Réservation';
    case 'restaurantPage':
      return 'Site restaurant';
    case 'restaurantSection': {
      const label = restaurantVariant
        ? RESTAURANT_SECTION_VARIANT_LABELS[restaurantVariant]
        : null;
      return label ? `Restaurant — ${label}` : 'Restaurant — bloc';
    }
    default:
      return type;
  }
}

export default function ComponentSettingsModal({
  target,
  sections,
  siteTypography,
  viewport = 'desktop',
  onClose,
  onSave,
  onLiveUpdate,
}) {
  const [draft, setDraft] = useState(null);
  const [tab, setTab] = useState('general');

  useEffect(() => {
    if (!target) {
      setDraft(null);
      return;
    }
    if (target.kind === 'section') {
      const sectionType = target.section.sectionType || 'normal';
      const liveSection = sections.find((s) => s.id === target.sectionId);
      const sourceSection = liveSection || target.section;
      setDraft({
        ...sourceSection,
        sectionType,
        background: sourceSection.background || createSectionBackground(sectionType),
        animation: sourceSection.animation || undefined,
      });
      setTab('general');
      return;
    }
    if (target.kind === 'pageMenu') {
      const comp = target.component;
      if (!comp) {
        setDraft(null);
        return;
      }
      setDraft({
        ...comp,
        type: comp.type || 'menu',
        props: {
          ...defaultComponentProps('menu'),
          componentBackground: { ...DEFAULT_COMPONENT_BACKGROUND },
          ...(comp.props || {}),
        },
      });
      setTab('navigation');
      return;
    }
    const comp = target.component;
    if (!comp) {
      setDraft(null);
      return;
    }
    const liveSection = sections.find((s) => s.id === target.sectionId);
    const liveComp = liveSection?.components?.find((c) => c.id === comp.id);
    const sourceComp = liveComp || comp;
    const props = {
      componentBackground: { ...DEFAULT_COMPONENT_BACKGROUND },
      ...(sourceComp.props || {}),
    };
    setDraft({ ...sourceComp, props });
    setTab(sourceComp.type === 'text' ? 'content' : sourceComp.type === 'menu' ? 'navigation' : 'content');
  }, [target]);

  if (!target || !draft) return null;

  const isSection = target.kind === 'section';
  const isDraftSynced = isSection
    ? draft.id === target.section?.id && !draft.type
    : target.kind === 'pageMenu'
      ? draft.id === target.component?.id && draft.type === 'menu' && draft.props
      : draft.id === target.component?.id && draft.type && draft.props;

  if (!isDraftSynced) return null;

  const type = isSection ? 'section' : draft.type;
  const props = draft.props || {};
  const tabs = getTabs(isSection, type);
  const modalWidth =
    type === 'text'
      ? 'max-w-5xl'
      : tab === 'animation'
        ? 'max-w-5xl'
        : 'max-w-2xl';
  const parentSection =
    !isSection && target.kind === 'component'
      ? sections.find((s) => s.id === target.sectionId)
      : null;
  const jardinsKitSite = siteUsesDesignKit({ sections }, 'jardins');
  const showJardinsKitStyleFields =
    jardinsKitSite && parentSection?.designKit === 'jardins';
  const paddingStyle = resolveComponentPadding(props);
  const hasSiteFont = siteHasCustomFont(siteTypography);

  const setProps = (patch) => {
    setDraft((prev) => {
      const next = {
        ...prev,
        props: { ...(prev.props || {}), ...patch },
      };
      onLiveUpdate?.(next);
      return next;
    });
  };

  const setProp = (key, value) => {
    setDraft((prev) => {
      const next = {
        ...prev,
        props: { ...(prev.props || {}), [key]: value },
      };
      onLiveUpdate?.(next);
      return next;
    });
  };

  const applySectionAnimation = (animation) => {
    setDraft((prev) => {
      const next = { ...prev, animation };
      onLiveUpdate?.(next);
      return next;
    });
  };

  const applyComponentAnimation = (animation) => {
    setDraft((prev) => {
      const next = setViewportAnimation(prev, viewport, animation);
      onLiveUpdate?.(next);
      return next;
    });
  };

  const viewportLabel =
    viewport === 'mobile' ? 'Mobile' : viewport === 'tablet' ? 'Tablette' : 'Desktop';
  const componentAnimation = getViewportAnimationSource(draft, viewport);
  const hasAnimationOverride = !isSection && hasViewportAnimationOverride(draft, viewport);

  const handleImageFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setProp('src', reader.result);
    reader.readAsDataURL(file);
  };

  const syncMenuTabOrder = (patch) => {
    const externalLinks = patch.externalLinks ?? props.externalLinks ?? [];
    const menuButtons = patch.menuButtons ?? props.menuButtons ?? [];
    const prevLinks = props.externalLinks || [];
    const prevButtons = props.menuButtons || [];
    const prevLinkIds = new Set(prevLinks.map((l) => l.id));
    const prevButtonIds = new Set(prevButtons.map((b) => b.id));
    const nextLinkIds = new Set(externalLinks.map((l) => l.id));
    const nextButtonIds = new Set(menuButtons.map((b) => b.id));

    let tabOrder =
      props.tabOrder?.length > 0
        ? [...props.tabOrder]
        : buildDefaultTabOrder(sections, prevLinks, prevButtons);

    tabOrder = tabOrder.filter((key) => {
      if (key.startsWith('link:')) return nextLinkIds.has(key.slice(5));
      if (key.startsWith('button:')) return nextButtonIds.has(key.slice(7));
      return true;
    });

    let tabAppearances = { ...(patch.tabAppearances ?? props.tabAppearances ?? {}) };

    for (const link of externalLinks) {
      if (!prevLinkIds.has(link.id)) {
        tabOrder.push(`link:${link.id}`);
      }
    }
    for (const btn of menuButtons) {
      if (!prevButtonIds.has(btn.id)) {
        tabOrder.push(`button:${btn.id}`);
        const tabKey = `button:${btn.id}`;
        if (!tabAppearances[tabKey]) {
          tabAppearances = {
            ...tabAppearances,
            [tabKey]: {
              variant: 'solid',
              shape: 'rounded',
              borderRadius: 8,
            },
          };
        }
      }
    }

    setProps({ ...patch, externalLinks, menuButtons, tabOrder, tabAppearances });
  };

  const handleExternalLinksChange = (externalLinks) => {
    syncMenuTabOrder({ externalLinks });
  };

  const handleMenuButtonsChange = (menuButtons) => {
    syncMenuTabOrder({ menuButtons });
  };

  const handleLogoFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setProp('logoUrl', reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <EditorModalPortal open={Boolean(target && draft)}>
      <div
        className={`w-full ${modalWidth} rounded-xl bg-card border border-border shadow-elevation-3 overflow-hidden flex flex-col max-h-[92vh]`}
      >
        <div className="flex items-center justify-between border-b border-border px-4 py-3 shrink-0">
          <h3 className="font-semibold text-foreground flex items-center gap-2">
            <Icon name="Settings" size={18} />
            {isSection ? 'Section' : `Composant ${typeLabel(type, props.variant)}`}
          </h3>
          <button type="button" onClick={onClose} className="p-2 rounded-lg hover:bg-muted">
            <Icon name="X" size={16} />
          </button>
        </div>

        <div className="flex border-b border-border shrink-0 overflow-x-auto">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`flex-1 min-w-[100px] flex items-center justify-center gap-1.5 px-3 py-2.5 text-xs font-medium transition-smooth whitespace-nowrap ${
                tab === t.id
                  ? 'text-primary border-b-2 border-primary bg-primary/5'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted/40'
              }`}
              onClick={() => setTab(t.id)}
            >
              <Icon name={t.icon} size={14} />
              {t.label}
            </button>
          ))}
        </div>

        <div
          className={`p-4 flex-1 min-h-0 ${
            tab === 'animation' ? 'overflow-hidden' : 'overflow-y-auto space-y-4'
          }`}
        >
          {isSection && tab === 'general' && (
            <>
              <Field label="Nom de l'onglet (menu)">
                <input
                  className={inputClass}
                  value={draft.label || ''}
                  onChange={(e) => setDraft({ ...draft, label: e.target.value })}
                />
              </Field>
              <Field label="Ancre (URL #...)">
                <input
                  className={inputClass}
                  value={draft.anchor || ''}
                  onChange={(e) => setDraft({ ...draft, anchor: e.target.value })}
                />
              </Field>
              <Field label="Espacement vertical (px)">
                <input
                  type="number"
                  className={inputClass}
                  value={draft.paddingY ?? 64}
                  onChange={(e) =>
                    setDraft({ ...draft, paddingY: Number(e.target.value) || 64 })
                  }
                />
              </Field>
              {jardinsKitSite || draft.designKit === 'jardins' ? (
                <SectionDesignKitField
                  designKit={draft.designKit}
                  kitSectionTone={draft.kitSectionTone}
                  onChangeKit={(v) => setDraft({ ...draft, designKit: v })}
                  onChangeTone={(v) => setDraft({ ...draft, kitSectionTone: v })}
                />
              ) : null}
              <SectionViewportVisibilityFields
                section={draft}
                viewport={viewport}
                onChange={setDraft}
              />
            </>
          )}

          {isSection && tab === 'appearance' && (
            <SectionBackgroundFields
              section={draft}
              onChange={(next) => setDraft(next)}
            />
          )}

          {isSection && tab === 'animation' && (
            <SectionAnimationFields
              animation={draft.animation}
              components={draft.components}
              onChange={applySectionAnimation}
            />
          )}

          {!isSection && tab === 'content' && type === 'text' && (
            <>
              <TextBlockTypographyFields props={props} setProp={setProp} />
              <WebCreatorTextEditor
                key={draft.id}
                value={props.content || DEFAULT_TEXT_HTML}
                onChange={(html) => {
                  setProps({ content: html, contentFormat: 'html' });
                }}
                inheritSiteFont={props.inheritSiteFont !== false}
                textFontFamily={props.textFontFamily}
                siteTypography={siteTypography}
                paddingStyle={paddingStyle}
                typographyProps={props}
              />
              {showJardinsKitStyleFields ? (
                <TextKitStyleField
                  kitStyle={props.kitStyle}
                  onChange={(v) => setProp('kitStyle', v || undefined)}
                />
              ) : null}
              <TextLinkFields props={props} setProp={setProp} />
            </>
          )}

          {!isSection && tab === 'content' && type === 'image' && (
            <>
              {showJardinsKitStyleFields ? (
                <ImageKitStyleField
                  kitStyle={props.kitStyle}
                  onChange={(v) => setProp('kitStyle', v || undefined)}
                />
              ) : null}
              <Field label="Texte alternatif">
                <input
                  className={inputClass}
                  value={props.alt || ''}
                  onChange={(e) => setProp('alt', e.target.value)}
                />
              </Field>
              <Field label="Image (URL)">
                <input
                  className={inputClass}
                  value={props.src || ''}
                  onChange={(e) => setProp('src', e.target.value)}
                  placeholder="https://..."
                />
              </Field>
              <Field label="Importer une image">
                <input type="file" accept="image/*" onChange={handleImageFile} className="text-sm" />
              </Field>
              {props.src ? (
                <div className="rounded-lg border border-border overflow-hidden bg-muted/30 p-3 flex justify-center">
                  <img
                    src={props.src}
                    alt=""
                    className="max-w-full max-h-48 object-contain"
                    style={{
                      borderRadius: `${resolveShapeRadius(props.shape, props.borderRadius)}px`,
                    }}
                  />
                </div>
              ) : null}
              <ShapeFields
                shape={props.shape}
                borderRadius={props.borderRadius}
                onChangeShape={(e) => setProp('shape', e.target.value)}
                onChangeRadius={(e) => setProp('borderRadius', Number(e.target.value))}
                previewLabel="Aperçu de la forme"
                preview={(radius) => {
                  const circle = props.shape === 'circle';
                  const boxStyle = circle
                    ? { borderRadius: '50%' }
                    : { borderRadius: `${radius}px` };
                  return props.src ? (
                    <img
                      src={props.src}
                      alt=""
                      className={`w-32 h-32 object-cover border border-border ${circle ? 'aspect-square' : ''}`}
                      style={boxStyle}
                    />
                  ) : (
                    <div
                      className="w-32 h-32 bg-neutral-200 border border-border flex items-center justify-center text-xs text-neutral-500"
                      style={boxStyle}
                    >
                      Image
                    </div>
                  );
                }}
              />
            </>
          )}

          {!isSection && tab === 'content' && type === 'cardFeature' && (
            <CardFeatureContentFields
              props={props}
              setProp={setProp}
              siteTypography={siteTypography}
              sections={sections}
            />
          )}

          {!isSection && tab === 'content' && type === 'cardIllustration' && (
            <CardIllustrationContentFields
              props={props}
              setProp={setProp}
              siteTypography={siteTypography}
            />
          )}

          {!isSection && tab === 'content' && type === 'cardSplit' && (
            <CardSplitContentFields
              props={props}
              setProp={setProp}
              siteTypography={siteTypography}
              sections={sections}
            />
          )}

          {!isSection && tab === 'content' && type === 'product' && (
            <>
              <CampaignProductFields props={props} onPatch={(patch) => setProps(patch)} />
              {props.productId && (props.imageUrl || resolveProductDisplay(props).title) ? (
                <div className="rounded-xl border border-border overflow-hidden bg-muted/20 max-w-xs mx-auto">
                  {props.imageUrl ? (
                    <img src={props.imageUrl} alt="" className="w-full aspect-[4/3] object-cover" />
                  ) : null}
                  <div className="p-3 space-y-1">
                    <p className="font-semibold text-sm">{resolveProductDisplay(props).title}</p>
                    {resolveProductDisplay(props).description ? (
                      <p className="text-xs text-muted-foreground line-clamp-2">
                        {resolveProductDisplay(props).description}
                      </p>
                    ) : null}
                    {props.price != null ? (
                      <p className="text-primary font-bold text-sm tabular-nums">
                        {formatProductPriceEur(props.price)} TTC
                      </p>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </>
          )}

          {!isSection && tab === 'content' && type === 'icon' && (
            <>
              <Field label="Icône">
                <IconPickerField
                  value={props.iconName}
                  onChange={(iconName) => setProp('iconName', iconName)}
                  previewColor={resolveIconStrokeColor(props.color, '#2563eb')}
                  previewSize={props.size ?? 32}
                />
              </Field>
              <Field label="Taille (px)">
                <input
                  type="range"
                  min={12}
                  max={128}
                  step={1}
                  className="w-full"
                  value={props.size ?? 32}
                  onChange={(e) => setProp('size', Number(e.target.value) || 32)}
                />
                <div className="flex items-center gap-2 mt-2">
                  <input
                    type="number"
                    min={12}
                    max={256}
                    className={inputClass}
                    value={props.size ?? 32}
                    onChange={(e) => setProp('size', Number(e.target.value) || 32)}
                  />
                </div>
              </Field>
              <ColorFillField
                label="Couleur de l'icône"
                value={props.color}
                onChange={(fill) => setProp('color', fill)}
                fallback="#2563eb"
              />
              <div className="rounded-xl border border-border bg-muted/20 p-6 flex items-center justify-center">
                <Icon
                  name={props.iconName || 'Star'}
                  size={Math.max(12, Math.min(128, Number(props.size) || 32))}
                  color={resolveIconStrokeColor(props.color, '#2563eb')}
                  strokeWidth={Math.max(1, Math.min(4, Number(props.strokeWidth) || 2))}
                />
              </div>
            </>
          )}

          {!isSection && tab === 'content' && type === 'dropdown' && (
            <>
              <Field label="Texte par défaut (placeholder)">
                <input
                  className={inputClass}
                  value={props.placeholder || ''}
                  onChange={(e) => setProp('placeholder', e.target.value)}
                  placeholder="Sélectionner une option…"
                />
              </Field>
              <DropdownOptionsFields
                options={props.options || []}
                sections={sections}
                onChange={(options) => setProp('options', options)}
              />
            </>
          )}

          {!isSection && tab === 'content' && type === 'divider' && (
            <>
              <Field label="Texte central (optionnel)">
                <input
                  className={inputClass}
                  value={props.label || ''}
                  onChange={(e) => setProp('label', e.target.value)}
                  placeholder="Ex. OU, Section suivante…"
                />
              </Field>
              <Field label="Largeur">
                <select
                  className={inputClass}
                  value={props.width || 'full'}
                  onChange={(e) => setProp('width', e.target.value)}
                >
                  <option value="full">Pleine largeur</option>
                  <option value="narrow">Réduite (centrée)</option>
                </select>
              </Field>
              {props.label ? (
                <Field label="Alignement du texte">
                  <select
                    className={inputClass}
                    value={props.align || 'center'}
                    onChange={(e) => setProp('align', e.target.value)}
                  >
                    <option value="left">Gauche</option>
                    <option value="center">Centre</option>
                    <option value="right">Droite</option>
                  </select>
                </Field>
              ) : null}
            </>
          )}

          {!isSection && tab === 'content' && type === 'badge' && (
            <>
              <Field label="Texte du badge">
                <input
                  className={inputClass}
                  value={props.text || ''}
                  onChange={(e) => setProp('text', e.target.value)}
                  placeholder="Nouveau, Promo -20%…"
                />
              </Field>
              <Field label="Alignement">
                <select
                  className={inputClass}
                  value={props.align || 'center'}
                  onChange={(e) => setProp('align', e.target.value)}
                >
                  <option value="left">Gauche</option>
                  <option value="center">Centre</option>
                  <option value="right">Droite</option>
                </select>
              </Field>
            </>
          )}

          {!isSection && tab === 'content' && type === 'quote' && (
            <>
              <Field label="Citation">
                <textarea
                  className={`${inputClass} min-h-[100px] resize-y`}
                  value={props.quote || ''}
                  onChange={(e) => setProp('quote', e.target.value)}
                  placeholder="Texte du témoignage…"
                />
              </Field>
              <Field label="Nom de l'auteur">
                <input
                  className={inputClass}
                  value={props.authorName || ''}
                  onChange={(e) => setProp('authorName', e.target.value)}
                />
              </Field>
              <Field label="Rôle / entreprise">
                <input
                  className={inputClass}
                  value={props.authorRole || ''}
                  onChange={(e) => setProp('authorRole', e.target.value)}
                />
              </Field>
              <Field label="Photo (URL)">
                <input
                  className={inputClass}
                  value={props.avatarUrl || ''}
                  onChange={(e) => setProp('avatarUrl', e.target.value)}
                  placeholder="https://…"
                />
              </Field>
              <Field label="Alignement">
                <select
                  className={inputClass}
                  value={props.align || 'left'}
                  onChange={(e) => setProp('align', e.target.value)}
                >
                  <option value="left">Gauche</option>
                  <option value="center">Centre</option>
                  <option value="right">Droite</option>
                </select>
              </Field>
              <label className="flex items-center gap-2 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={props.showQuoteMark !== false}
                  onChange={(e) => setProp('showQuoteMark', e.target.checked)}
                />
                Afficher le guillemet décoratif
              </label>
              <label className="flex items-center gap-2 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={props.cardStyle !== false}
                  onChange={(e) => setProp('cardStyle', e.target.checked)}
                />
                Style carte (fond + bordure)
              </label>
            </>
          )}

          {!isSection && tab === 'content' && type === 'button' && (
            <>
              <Field label="Texte du bouton">
                <input
                  className={inputClass}
                  value={props.label || ''}
                  onChange={(e) => setProp('label', e.target.value)}
                />
              </Field>
              {showJardinsKitStyleFields ? (
                <ButtonKitStyleField
                  kitStyle={props.kitStyle}
                  onChange={(v) => setProp('kitStyle', v || undefined)}
                />
              ) : null}
              <Field label="Type de lien">
                <select
                  className={inputClass}
                  value={props.linkType || 'section'}
                  onChange={(e) => setProp('linkType', e.target.value)}
                >
                  <option value="section">Section de la page</option>
                  <option value="publicPath">Page publique (commande…)</option>
                  <option value="url">URL externe</option>
                </select>
              </Field>
              {props.linkType === 'url' ? (
                <Field label="URL">
                  <input
                    className={inputClass}
                    value={props.url || ''}
                    onChange={(e) => setProp('url', e.target.value)}
                  />
                </Field>
              ) : props.linkType === 'publicPath' ? (
                <Field label="Chemin (ex. /commande)">
                  <input
                    className={inputClass}
                    value={props.publicPath || ''}
                    onChange={(e) => setProp('publicPath', e.target.value)}
                    placeholder="/commande"
                  />
                </Field>
              ) : (
                <Field label="Section cible">
                  <select
                    className={inputClass}
                    value={props.sectionAnchor || ''}
                    onChange={(e) => setProp('sectionAnchor', e.target.value)}
                  >
                    {sections.map((s) => (
                      <option key={s.id} value={s.anchor}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </Field>
              )}
            </>
          )}

          {!isSection &&
            tab === 'content' &&
            (type === 'clickAndCollect' || type === 'reservation') && (
              <>
                <Field label="Affichage">
                  <select
                    className={inputClass}
                    value={props.displayMode === 'button' ? 'button' : 'inline'}
                    onChange={(e) => setProp('displayMode', e.target.value)}
                  >
                    <option value="inline">Intégré sur la page (recommandé)</option>
                    <option value="button">Bouton vers une page dédiée</option>
                  </select>
                </Field>
                {props.displayMode === 'button' ? (
                  <Field label="Texte du bouton">
                    <input
                      className={inputClass}
                      value={props.label || ''}
                      onChange={(e) => setProp('label', e.target.value)}
                    />
                  </Field>
                ) : null}
                {type === 'reservation' && props.displayMode !== 'button' ? (
                  <Field label="Style du bloc">
                    <select
                      className={inputClass}
                      value={props.theme === 'restaurant' ? 'restaurant' : 'default'}
                      onChange={(e) => setProp('theme', e.target.value)}
                    >
                      <option value="restaurant">
                        Restaurant (carte verte, modèle Jardins)
                      </option>
                      <option value="default">Classique (carte neutre intégrée)</option>
                    </select>
                  </Field>
                ) : null}
                {type === 'clickAndCollect' ? (
                  <>
                    <Field label="Sous-titre de la page menu (optionnel)">
                      <input
                        className={inputClass}
                        value={props.menuPage?.pageSubtitle ?? ''}
                        onChange={(e) =>
                          setProp('menuPage', {
                            ...(props.menuPage || {}),
                            pageSubtitle: e.target.value,
                          })
                        }
                      />
                    </Field>
                    <Field label="Style de carte">
                      <select
                        className={inputClass}
                        value={props.menuPage?.layout || 'classic'}
                        onChange={(e) =>
                          setProp('menuPage', {
                            ...(props.menuPage || {}),
                            layout: e.target.value,
                          })
                        }
                      >
                        <option value="classic">Liste restaurant</option>
                        <option value="gallery">Grille photos</option>
                      </select>
                    </Field>
                  </>
                ) : (
                  <>
                    <Field label="Titre du formulaire (optionnel)">
                      <input
                        className={inputClass}
                        value={props.reservationPage?.formTitle ?? ''}
                        onChange={(e) =>
                          setProp('reservationPage', {
                            ...(props.reservationPage || {}),
                            formTitle: e.target.value,
                          })
                        }
                      />
                    </Field>
                    <Field label="Sous-titre (optionnel)">
                      <input
                        className={inputClass}
                        value={props.reservationPage?.formSubtitle ?? ''}
                        onChange={(e) =>
                          setProp('reservationPage', {
                            ...(props.reservationPage || {}),
                            formSubtitle: e.target.value,
                          })
                        }
                      />
                    </Field>
                    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
                      <p className="text-xs font-semibold text-foreground">Boutons du formulaire</p>
                      <Field label="Texte du bouton d&apos;envoi">
                        <input
                          className={inputClass}
                          value={props.reservationPage?.submitButtonLabel ?? ''}
                          placeholder="Demander ma réservation"
                          onChange={(e) =>
                            setProp('reservationPage', {
                              ...(props.reservationPage || {}),
                              submitButtonLabel: e.target.value,
                            })
                          }
                        />
                      </Field>
                      <Field label="Texte pendant l&apos;envoi (optionnel)">
                        <input
                          className={inputClass}
                          value={props.reservationPage?.submitButtonLabelBusy ?? ''}
                          placeholder="Envoi…"
                          onChange={(e) =>
                            setProp('reservationPage', {
                              ...(props.reservationPage || {}),
                              submitButtonLabelBusy: e.target.value,
                            })
                          }
                        />
                      </Field>
                      <ColorFillField
                        label="Couleur d'accent (calendrier, créneaux, + convives)"
                        value={props.reservationPage?.accentColor}
                        onChange={(fill) =>
                          setProp('reservationPage', {
                            ...(props.reservationPage || {}),
                            accentColor: fill,
                          })
                        }
                        fallback="#0f766e"
                      />
                      <ColorFillField
                        label="Fond du bouton d'envoi"
                        value={props.reservationPage?.buttonColor}
                        onChange={(fill) =>
                          setProp('reservationPage', {
                            ...(props.reservationPage || {}),
                            buttonColor: fill,
                          })
                        }
                        fallback="#0f766e"
                      />
                      <ColorFillField
                        label="Texte du bouton d'envoi"
                        value={props.reservationPage?.buttonTextColor}
                        onChange={(fill) =>
                          setProp('reservationPage', {
                            ...(props.reservationPage || {}),
                            buttonTextColor: fill,
                          })
                        }
                        fallback="#ffffff"
                      />
                    </div>
                  </>
                )}
                <p className="text-xs text-muted-foreground rounded-lg border border-border bg-muted/30 p-3">
                  {type === 'clickAndCollect' ? (
                    <>
                      Carte, plats et stocks : <strong>Administration → Menu</strong>. Ici : mode
                      d&apos;affichage et raccourcis carte.
                    </>
                  ) : (
                    <>
                      Créneaux et demandes : <strong>Administration</strong>. Ici : mode intégré,
                      textes et couleurs des boutons du formulaire.
                    </>
                  )}
                </p>
              </>
            )}

          {!isSection && tab === 'content' && type === 'hubupQr' && (
            <>
              <HubupCommunityFields
                groupId={props.groupId || ''}
                onPatch={(patch) => setProps(patch)}
              />
              <label className="flex items-center gap-2 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={props.showLabel !== false}
                  onChange={(e) => setProp('showLabel', e.target.checked)}
                />
                Afficher le nom de la communauté sous le QR
              </label>
              <p className="text-xs text-muted-foreground">
                Redimensionnez le composant sur la grille pour ajuster la taille du QR.
              </p>
            </>
          )}

          {!isSection && tab === 'content' && type === 'hubupNotifications' && (
            <>
              <HubupCommunityFields
                groupId={props.groupId || ''}
                topicId={props.topicId || ''}
                showTopic
                showCount
                notificationCount={props.notificationCount || 3}
                onPatch={(patch) => setProps(patch)}
              />
              <p className="text-xs text-muted-foreground">
                Affiche 1 à 3 dernières notifications. Le contenu est tronqué si la zone
                est trop petite — le reste de la page n&apos;est jamais décalé.
              </p>
            </>
          )}

          {!isSection &&
            tab === 'content' &&
            (type === 'restaurantPage' || type === 'restaurantSection') && (
              <RestaurantContentSettingsFields
                props={props}
                setProp={setProp}
                setProps={setProps}
                siteTypography={siteTypography}
                variant={type === 'restaurantSection' ? props.variant : null}
                componentType={type}
              />
            )}

          {!isSection && tab === 'navigation' && type === 'menu' && (
            <>
              <MenuTypographyFields
                props={props}
                setProp={setProp}
                setProps={setProps}
                siteTypography={siteTypography}
              />
              <Field label="Logo (URL)">
                <input
                  className={inputClass}
                  value={props.logoUrl || ''}
                  onChange={(e) => setProp('logoUrl', e.target.value)}
                />
              </Field>
              <Field label="Importer un logo">
                <input type="file" accept="image/*" onChange={handleLogoFile} className="text-sm" />
              </Field>
              <Field label="Position du logo">
                <select
                  className={inputClass}
                  value={props.logoPosition || 'left'}
                  onChange={(e) => setProp('logoPosition', e.target.value)}
                >
                  <option value="left">Gauche</option>
                  <option value="center">Centre</option>
                  <option value="right">Droite</option>
                </select>
              </Field>
              <label className="flex items-start gap-3 rounded-lg border border-border p-3 bg-muted/10 cursor-pointer">
                <input
                  type="checkbox"
                  className="mt-0.5"
                  checked={props.menuFreeLayout === true}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const entries = getMenuTabOrderEditorEntries(sections, props);
                      setProps({
                        ...props,
                        menuFreeLayout: true,
                        tabPlacements: buildDefaultTabPlacements(entries),
                      });
                    } else {
                      setProp('menuFreeLayout', false);
                    }
                  }}
                />
                <span>
                  <span className="text-sm font-medium text-foreground block">
                    Disposition libre des boutons (ordinateur)
                  </span>
                  <span className="text-xs text-muted-foreground">
                    Glissez le logo et les onglets sur la barre en vue ordinateur (48 colonnes × 3
                    lignes).
                  </span>
                </span>
              </label>

              {props.menuFreeLayout !== true ? (
                <Field label="Position des onglets (ordinateur)">
                  <select
                    className={inputClass}
                    value={props.tabsPosition || 'right'}
                    onChange={(e) => setProp('tabsPosition', e.target.value)}
                  >
                    <option value="left">Gauche</option>
                    <option value="center">Centre</option>
                    <option value="right">Droite</option>
                  </select>
                </Field>
              ) : null}

              <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
                <p className="text-xs font-semibold text-foreground">
                  Tablette &amp; téléphone
                </p>
                <Field label="Style du menu">
                  <select
                    className={inputClass}
                    value={props.mobileMenuStyle || 'hamburger'}
                    onChange={(e) => setProp('mobileMenuStyle', e.target.value)}
                  >
                    <option value="hamburger">Menu hamburger</option>
                    <option value="tabs">Onglets empilés</option>
                  </select>
                </Field>
                <Field label="Position du logo">
                  <select
                    className={inputClass}
                    value={props.compactLogoPosition || props.logoPosition || 'left'}
                    onChange={(e) => setProp('compactLogoPosition', e.target.value)}
                  >
                    <option value="left">Gauche</option>
                    <option value="center">Centre</option>
                    <option value="right">Droite</option>
                  </select>
                </Field>
                <Field label="Position du bouton menu">
                  <select
                    className={inputClass}
                    value={props.compactMenuAlign || 'right'}
                    onChange={(e) => setProp('compactMenuAlign', e.target.value)}
                  >
                    <option value="left">Gauche</option>
                    <option value="right">Droite</option>
                  </select>
                </Field>
              </div>

              <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
                <p className="text-xs font-semibold text-foreground">Arrondi des onglets (menu entier)</p>
                <MenuTabShapeFields
                  shape={props.menuTabShape || 'rounded'}
                  borderRadius={props.menuTabBorderRadius ?? 8}
                  onChangeShape={(v) => setProp('menuTabShape', v || 'rounded')}
                  onChangeRadius={(n) => setProp('menuTabBorderRadius', n)}
                />
                <p className="text-[11px] text-muted-foreground leading-relaxed">
                  S&apos;applique à tous les onglets et boutons. Chaque entrée peut surcharger dans
                  son bloc ou dans la liste d&apos;ordre.
                </p>
              </div>

              <MenuButtonsFields
                buttons={props.menuButtons || []}
                sections={sections}
                menuProps={props}
                onChange={handleMenuButtonsChange}
                onChangeTabHoverEffect={(key, cfg) => {
                  const prev = { ...(props.tabHoverEffects || {}) };
                  if (cfg == null) {
                    delete prev[key];
                    setProp('tabHoverEffects', prev);
                    return;
                  }
                  setProp('tabHoverEffects', { ...prev, [key]: cfg });
                }}
                onChangeTabAppearance={(key, cfg) => {
                  const prev = { ...(props.tabAppearances || {}) };
                  if (cfg == null) {
                    delete prev[key];
                    setProp('tabAppearances', prev);
                    return;
                  }
                  setProp('tabAppearances', { ...prev, [key]: cfg });
                }}
                onChangeTabPlacement={(key, placement) => {
                  setProp('tabPlacements', {
                    ...(props.tabPlacements || {}),
                    [key]: placement,
                  });
                }}
              />
              <MenuExternalLinksFields
                links={props.externalLinks || []}
                sections={sections}
                onChange={handleExternalLinksChange}
              />
              <MenuTabsOrderFields
                sections={sections}
                menuProps={props}
                onChangeTabOrder={(tabOrder) => setProp('tabOrder', tabOrder)}
                onChangeHiddenMenuSectionIds={(ids) => setProp('hiddenMenuSectionIds', ids)}
                onChangeTabHoverEffect={(key, cfg) => {
                  const prev = { ...(props.tabHoverEffects || {}) };
                  if (cfg == null) {
                    delete prev[key];
                    setProp('tabHoverEffects', prev);
                    return;
                  }
                  setProp('tabHoverEffects', { ...prev, [key]: cfg });
                }}
                onChangeTabAppearance={(key, cfg) => {
                  const prev = { ...(props.tabAppearances || {}) };
                  if (cfg == null) {
                    delete prev[key];
                    setProp('tabAppearances', prev);
                    return;
                  }
                  setProp('tabAppearances', { ...prev, [key]: cfg });
                }}
                onChangeTabPlacement={(key, placement) => {
                  setProp('tabPlacements', {
                    ...(props.tabPlacements || {}),
                    [key]: placement,
                  });
                }}
              />
              <p className="text-xs text-muted-foreground">
                Les boutons personnalisés se configurent entièrement dans leur bloc (couleurs,
                forme, survol, épinglé à droite). Réordonnez sections, liens et boutons ci-dessous.
              </p>
            </>
          )}

          {!isSection && tab === 'appearance' && (
            <>
              {type !== 'menu' && (
                <PaddingFields props={props} onChange={(nextProps) => setProps(nextProps)} />
              )}

              {type === 'text' && hasSiteFont && (
                <>
                  <label className="flex items-start gap-3 rounded-lg border border-border p-3 bg-muted/10 cursor-pointer">
                    <input
                      type="checkbox"
                      className="mt-0.5"
                      checked={props.inheritSiteFont !== false}
                      onChange={(e) => setProp('inheritSiteFont', e.target.checked)}
                    />
                    <span>
                      <span className="text-sm font-medium text-foreground block">
                        Hériter de la police par défaut du site
                      </span>
                      <span className="text-xs text-muted-foreground">
                        {(() => {
                          const def = getSiteDefaultFont(siteTypography);
                          return def
                            ? `Applique « ${def.label || def.fontFamily} » à ce bloc.`
                            : 'Utilise la police par défaut configurée dans les paramètres du site.';
                        })()}
                      </span>
                    </span>
                  </label>
                  {props.inheritSiteFont === false ? (
                    <FontFamilySelectField
                      value={props.textFontFamily || 'system'}
                      onChange={(v) => setProp('textFontFamily', v)}
                      siteTypography={siteTypography}
                    />
                  ) : null}
                </>
              )}

              {type === 'text' ? (
                <TextComponentEffectFields props={props} setProp={setProp} />
              ) : null}

              {type === 'image' ? (
                <>
                  <Field label="Cadrage dans la zone">
                    <select
                      className={inputClass}
                      value={props.objectFit || 'fill'}
                      onChange={(e) => setProp('objectFit', e.target.value)}
                    >
                      <option value="fill">Étirer sur la hitbox (déforme si besoin)</option>
                      <option value="cover">Remplir (conserve les proportions, recadre)</option>
                      <option value="contain">Contenir (proportions, bandes vides)</option>
                    </select>
                  </Field>
                  <Field label={`Zoom (${props.imageZoom ?? 100}%)`}>
                    <input
                      type="range"
                      min={50}
                      max={250}
                      step={5}
                      className="w-full"
                      value={props.imageZoom ?? 100}
                      onChange={(e) => setProp('imageZoom', Number(e.target.value))}
                    />
                  </Field>
                  <p className="text-[11px] text-muted-foreground leading-relaxed">
                    En redimensionnant le bloc sur la grille, l&apos;image suit la hitbox avec le
                    mode « Étirer ». Le zoom ci-dessus est un réglage fin en plus (optionnel).
                  </p>
                  <HoverEffectFields
                    props={props}
                    setProp={setProp}
                    prefix="image"
                    title="Effets au survol (image)"
                  />
                </>
              ) : null}

              {type === 'text' ? (
                <HoverEffectFields
                  props={props}
                  setProp={setProp}
                  prefix="content"
                  title="Effets au survol (bloc texte)"
                  hint="Soulignement, zoom, surbrillance… au survol du bloc sur le site publié."
                />
              ) : null}

              {type === 'button' ? (
                <HoverEffectFields
                  props={props}
                  setProp={setProp}
                  prefix="button"
                  title="Effets au survol (bouton)"
                  hint={
                    props.kitStyle
                      ? 'Remplace le survol du style kit lorsque l’effet n’est pas « Aucun ».'
                      : undefined
                  }
                />
              ) : null}

              {type === 'product' && (
                <ShapeFields
                  shape={props.shape}
                  borderRadius={props.borderRadius}
                  onChangeShape={(e) => setProp('shape', e.target.value)}
                  onChangeRadius={(e) => setProp('borderRadius', Number(e.target.value))}
                  previewLabel="Aperçu carte"
                  preview={(radius) => (
                    <div
                      className="w-full max-w-[200px] overflow-hidden border border-border bg-card"
                      style={{ borderRadius: `${radius}px` }}
                    >
                      {props.imageUrl ? (
                        <img src={props.imageUrl} alt="" className="w-full aspect-[4/3] object-cover" />
                      ) : (
                        <div className="w-full aspect-[4/3] bg-muted flex items-center justify-center text-xs text-muted-foreground">
                          Image
                        </div>
                      )}
                      <div className="p-2 text-xs font-medium truncate">
                        {resolveProductDisplay(props).title}
                      </div>
                    </div>
                  )}
                />
              )}

              {type === 'icon' && (
                <>
                  <Field label="Alignement horizontal">
                    <select
                      className={inputClass}
                      value={props.align || 'center'}
                      onChange={(e) => setProp('align', e.target.value)}
                    >
                      <option value="left">Gauche</option>
                      <option value="center">Centre</option>
                      <option value="right">Droite</option>
                    </select>
                  </Field>
                  <Field label="Épaisseur du trait">
                    <input
                      type="range"
                      min={1}
                      max={4}
                      step={0.5}
                      className="w-full"
                      value={props.strokeWidth ?? 2}
                      onChange={(e) => setProp('strokeWidth', Number(e.target.value) || 2)}
                    />
                  </Field>
                </>
              )}

              {(type === 'button' ||
                type === 'clickAndCollect' ||
                type === 'reservation') && (
                <>
                  <ColorFillField
                    label="Couleur du bouton"
                    value={props.backgroundColor}
                    onChange={(fill) => setProp('backgroundColor', fill)}
                    fallback="#2563eb"
                  />
                  <ColorFillField
                    label="Couleur du texte"
                    value={props.textColor}
                    onChange={(fill) => setProp('textColor', fill)}
                    fallback="#ffffff"
                  />
                  <ShapeFields
                    shape={props.shape}
                    borderRadius={props.borderRadius}
                    onChangeShape={(e) => setProp('shape', e.target.value)}
                    onChangeRadius={(e) => setProp('borderRadius', Number(e.target.value))}
                    previewLabel="Aperçu du bouton"
                    preview={() => {
                      const { button: btnStyle, text: textStyle } = resolveButtonStyle(
                        props,
                        siteTypography,
                      );
                      return (
                        <button
                          type="button"
                          className={`pointer-events-none px-6 py-3 shadow-sm ${
                            props.width === 'full' ? 'w-full max-w-xs' : ''
                          } ${props.shape === 'circle' ? 'min-w-[56px] min-h-[56px] p-0 inline-flex items-center justify-center' : ''}`}
                          style={btnStyle}
                        >
                          <span style={textStyle}>{props.label || 'Bouton'}</span>
                        </button>
                      );
                    }}
                  />
                  <ButtonTypographyFields
                    props={props}
                    setProp={setProp}
                    siteTypography={siteTypography}
                  />
                  <Field label="Largeur">
                    <select
                      className={inputClass}
                      value={props.width || 'auto'}
                      onChange={(e) => setProp('width', e.target.value)}
                    >
                      <option value="auto">Automatique</option>
                      <option value="full">Pleine largeur</option>
                    </select>
                  </Field>
                  <Field label="Taille du texte (px)">
                    <input
                      type="number"
                      min={10}
                      max={48}
                      className={inputClass}
                      value={props.fontSize ?? 14}
                      onChange={(e) => setProp('fontSize', Number(e.target.value) || 14)}
                    />
                  </Field>
                  <Field label="Épaisseur du texte">
                    <select
                      className={inputClass}
                      value={props.fontWeight ?? 500}
                      onChange={(e) => setProp('fontWeight', Number(e.target.value))}
                    >
                      <option value={400}>Normal</option>
                      <option value={500}>Moyen</option>
                      <option value={600}>Semi-gras</option>
                      <option value={700}>Gras</option>
                    </select>
                  </Field>
                  <Field label="Bordure (px)">
                    <input
                      type="number"
                      min={0}
                      max={12}
                      className={inputClass}
                      value={props.borderWidth ?? 0}
                      onChange={(e) => setProp('borderWidth', Number(e.target.value) || 0)}
                    />
                  </Field>
                  {props.borderWidth > 0 ? (
                    <ColorFillField
                      label="Couleur de bordure"
                      value={props.borderColor}
                      onChange={(fill) => setProp('borderColor', fill)}
                      fallback="#2563eb"
                    />
                  ) : null}
                </>
              )}

              {type === 'dropdown' && (
                <>
                  <ColorFillField
                    label="Fond du sélecteur"
                    value={props.backgroundColor}
                    onChange={(fill) => setProp('backgroundColor', fill)}
                    fallback="#ffffff"
                  />
                  <ColorFillField
                    label="Texte du sélecteur"
                    value={props.textColor}
                    onChange={(fill) => setProp('textColor', fill)}
                    fallback="#1c1917"
                  />
                  <ColorFillField
                    label="Fond du menu ouvert"
                    value={props.menuBackgroundColor}
                    onChange={(fill) => setProp('menuBackgroundColor', fill)}
                    fallback="#ffffff"
                  />
                  <ColorFillField
                    label="Texte des options"
                    value={props.menuTextColor}
                    onChange={(fill) => setProp('menuTextColor', fill)}
                    fallback="#1c1917"
                  />
                  <ButtonTypographyFields
                    props={props}
                    setProp={setProp}
                    siteTypography={siteTypography}
                  />
                  <ShapeFields
                    shape={props.shape}
                    borderRadius={props.borderRadius}
                    onChangeShape={(e) => setProp('shape', e.target.value)}
                    onChangeRadius={(e) => setProp('borderRadius', Number(e.target.value))}
                    previewLabel="Aperçu"
                    preview={() => {
                      const { trigger, text } = resolveDropdownStyle(props, siteTypography);
                      return (
                        <button
                          type="button"
                          className={`pointer-events-none w-full max-w-xs flex items-center justify-between gap-2 px-3 py-2.5 shadow-sm ${
                            props.width === 'full' ? 'w-full' : ''
                          }`}
                          style={trigger}
                        >
                          <span className="truncate" style={text}>
                            {props.placeholder || 'Sélectionner…'}
                          </span>
                          <Icon name="ChevronDown" size={16} />
                        </button>
                      );
                    }}
                  />
                  <Field label="Largeur">
                    <select
                      className={inputClass}
                      value={props.width || 'full'}
                      onChange={(e) => setProp('width', e.target.value)}
                    >
                      <option value="auto">Automatique</option>
                      <option value="full">Pleine largeur</option>
                    </select>
                  </Field>
                  <Field label="Taille du texte (px)">
                    <input
                      type="number"
                      min={10}
                      max={48}
                      className={inputClass}
                      value={props.fontSize ?? 14}
                      onChange={(e) => setProp('fontSize', Number(e.target.value) || 14)}
                    />
                  </Field>
                  <Field label="Épaisseur du texte">
                    <select
                      className={inputClass}
                      value={props.fontWeight ?? 500}
                      onChange={(e) => setProp('fontWeight', Number(e.target.value))}
                    >
                      <option value={400}>Normal</option>
                      <option value={500}>Moyen</option>
                      <option value={600}>Semi-gras</option>
                      <option value={700}>Gras</option>
                    </select>
                  </Field>
                  <Field label="Bordure (px)">
                    <input
                      type="number"
                      min={0}
                      max={12}
                      className={inputClass}
                      value={props.borderWidth ?? 1}
                      onChange={(e) => setProp('borderWidth', Number(e.target.value) || 0)}
                    />
                  </Field>
                  {props.borderWidth > 0 ? (
                    <ColorFillField
                      label="Couleur de bordure"
                      value={props.borderColor}
                      onChange={(fill) => setProp('borderColor', fill)}
                      fallback="#e5e7eb"
                    />
                  ) : null}
                </>
              )}

              {type === 'divider' && (
                <>
                  <ColorFillField
                    label="Couleur de la ligne"
                    value={props.lineColor}
                    onChange={(fill) => setProp('lineColor', fill)}
                    fallback="#e5e7eb"
                  />
                  <Field label="Style de ligne">
                    <select
                      className={inputClass}
                      value={props.lineStyle || 'solid'}
                      onChange={(e) => setProp('lineStyle', e.target.value)}
                    >
                      <option value="solid">Pleine</option>
                      <option value="dashed">Tirets</option>
                      <option value="dotted">Pointillés</option>
                    </select>
                  </Field>
                  <Field label="Épaisseur (px)">
                    <input
                      type="number"
                      min={1}
                      max={8}
                      className={inputClass}
                      value={props.thickness ?? 1}
                      onChange={(e) => setProp('thickness', Number(e.target.value) || 1)}
                    />
                  </Field>
                  {props.label ? (
                    <ColorFillField
                      label="Couleur du texte"
                      value={props.labelColor}
                      onChange={(fill) => setProp('labelColor', fill)}
                      fallback="#64748b"
                    />
                  ) : null}
                </>
              )}

              {type === 'badge' && (
                <>
                  <ColorFillField
                    label="Fond"
                    value={props.backgroundColor}
                    onChange={(fill) => setProp('backgroundColor', fill)}
                    fallback="#2563eb"
                  />
                  <ColorFillField
                    label="Texte"
                    value={props.textColor}
                    onChange={(fill) => setProp('textColor', fill)}
                    fallback="#ffffff"
                  />
                  <ShapeFields
                    shape={props.shape}
                    borderRadius={props.borderRadius}
                    onChangeShape={(e) => setProp('shape', e.target.value)}
                    onChangeRadius={(e) => setProp('borderRadius', Number(e.target.value))}
                    previewLabel="Aperçu"
                    preview={() => {
                      const { badge, text } = resolveBadgeStyle(props);
                      return (
                        <span className="pointer-events-none inline-flex" style={badge}>
                          <span style={text}>{props.text || 'Badge'}</span>
                        </span>
                      );
                    }}
                  />
                  <Field label="Taille du texte (px)">
                    <input
                      type="number"
                      min={9}
                      max={24}
                      className={inputClass}
                      value={props.fontSize ?? 12}
                      onChange={(e) => setProp('fontSize', Number(e.target.value) || 12)}
                    />
                  </Field>
                  <Field label="Épaisseur du texte">
                    <select
                      className={inputClass}
                      value={props.fontWeight ?? 600}
                      onChange={(e) => setProp('fontWeight', Number(e.target.value))}
                    >
                      <option value={400}>Normal</option>
                      <option value={500}>Moyen</option>
                      <option value={600}>Semi-gras</option>
                      <option value={700}>Gras</option>
                    </select>
                  </Field>
                </>
              )}

              {type === 'quote' && (
                <>
                  <ColorFillField
                    label="Couleur d'accent"
                    value={props.accentColor}
                    onChange={(fill) => setProp('accentColor', fill)}
                    fallback="#2563eb"
                  />
                </>
              )}

              {type === 'cardFeature' && (
                <>
                  <CardSharedAppearanceFields props={props} setProp={setProp} />
                  <CardFeatureAppearanceFields props={props} setProp={setProp} />
                </>
              )}

              {type === 'cardIllustration' && (
                <>
                  <CardSharedAppearanceFields props={props} setProp={setProp} />
                  <CardIllustrationAppearanceFields props={props} setProp={setProp} />
                </>
              )}

              {type === 'cardSplit' && (
                <>
                  <CardSharedAppearanceFields props={props} setProp={setProp} />
                  <CardSplitAppearanceFields
                    props={props}
                    setProp={setProp}
                    siteTypography={siteTypography}
                  />
                </>
              )}

              {type === 'menu' && (
                <>
                  <PaddingFields props={props} onChange={(nextProps) => setProps(nextProps)} />
                  <label className="flex items-start gap-3 rounded-lg border border-border p-3 bg-muted/10 cursor-pointer">
                    <input
                      type="checkbox"
                      className="mt-0.5"
                      checked={props.overlayFirstSection === true}
                      onChange={(e) => setProp('overlayFirstSection', e.target.checked)}
                    />
                    <span className="text-sm">
                      <span className="font-medium text-foreground block">
                        Menu transparent sur la 1<sup>re</sup> section
                      </span>
                      <span className="text-xs text-muted-foreground mt-1 block">
                        Le menu se superpose au haut de page (hero). Au défilement, le fond
                        ci-dessous s&apos;applique.
                      </span>
                    </span>
                  </label>
                  {props.overlayFirstSection ? (
                    <ColorFillField
                      label="Couleur de fond au défilement"
                      value={props.scrollBackgroundColor || props.backgroundColor}
                      onChange={(fill) => setProp('scrollBackgroundColor', fill)}
                      fallback="#ffffff"
                    />
                  ) : (
                    <ColorFillField
                      label="Couleur de fond"
                      value={props.backgroundColor}
                      onChange={(fill) => setProp('backgroundColor', fill)}
                      fallback="#ffffff"
                    />
                  )}
                  <ColorFillField
                    label="Couleur du texte"
                    value={props.textColor}
                    onChange={(fill) => setProp('textColor', fill)}
                    fallback="#111827"
                  />
                  <MenuTypographyFields
                    props={props}
                    setProp={setProp}
                    setProps={setProps}
                    siteTypography={siteTypography}
                  />
                  <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
                    <p className="text-xs font-semibold text-foreground">Style des onglets (défaut)</p>
                    <Field label="Apparence par défaut">
                      <select
                        className={inputClass}
                        value={props.menuTabDefaultVariant === 'solid' ? 'solid' : 'transparent'}
                        onChange={(e) => setProp('menuTabDefaultVariant', e.target.value)}
                      >
                        <option value="transparent">Transparent</option>
                        <option value="solid">Bouton plein</option>
                      </select>
                    </Field>
                    <ColorFillField
                      label="Fond des boutons pleins"
                      value={props.menuTabSolidBackground}
                      onChange={(fill) => setProp('menuTabSolidBackground', fill)}
                      fallback="#ffffff"
                    />
                    <ColorFillField
                      label="Texte des boutons pleins (optionnel)"
                      value={props.menuTabSolidTextColor || props.textColor}
                      onChange={(fill) => setProp('menuTabSolidTextColor', fill)}
                      fallback="#111827"
                    />
                    <MenuTabShapeFields
                      shape={props.menuTabShape || 'rounded'}
                      borderRadius={props.menuTabBorderRadius ?? 8}
                      onChangeShape={(v) => setProp('menuTabShape', v || 'rounded')}
                      onChangeRadius={(n) => setProp('menuTabBorderRadius', n)}
                    />
                    <p className="text-[11px] text-muted-foreground leading-relaxed">
                      Forme et arrondi par défaut. Affinage par onglet dans{' '}
                      <strong className="font-medium text-foreground">Navigation</strong>.
                    </p>
                  </div>
                </>
              )}

              {type !== 'menu' && (
                <BackgroundFields
                  label="Fond du composant"
                  showEnableToggle
                  value={props.componentBackground}
                  onChange={(componentBackground) => setProp('componentBackground', componentBackground)}
                />
              )}
            </>
          )}

          {!isSection && tab === 'responsive' && (
            <ViewportVisibilityFields
              comp={draft}
              viewport={viewport}
              onChange={(next) => {
                setDraft(next);
                onLiveUpdate?.(next);
              }}
            />
          )}

          {!isSection && tab === 'animation' && (
            <>
              {viewport !== 'desktop' ? (
                <div className="rounded-lg border border-border bg-muted/20 px-3 py-2 text-xs text-muted-foreground flex items-center justify-between gap-2">
                  <span>
                    Animation pour <strong className="text-foreground">{viewportLabel}</strong>
                    {hasAnimationOverride ? ' · override actif' : ' · hérite du desktop si non modifiée'}
                  </span>
                  {hasAnimationOverride ? (
                    <button
                      type="button"
                      className="text-primary hover:underline shrink-0"
                      onClick={() => {
                        setDraft((prev) => {
                          const next = clearViewportAnimationOverride(prev, viewport);
                          onLiveUpdate?.(next);
                          return next;
                        });
                      }}
                    >
                      Réinitialiser
                    </button>
                  ) : null}
                </div>
              ) : null}
              <ComponentAnimationFields
                animation={componentAnimation}
                componentType={type}
                componentId={draft.id}
                sectionComponents={parentSection?.components || []}
                sectionAnimation={parentSection?.animation}
                viewport={viewport}
                onChange={applyComponentAnimation}
              />
            </>
          )}
        </div>

        <div className="flex justify-end gap-2 border-t border-border px-4 py-3 shrink-0">
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button onClick={() => onSave(draft)}>Enregistrer</Button>
        </div>
      </div>
    </EditorModalPortal>
  );
}
